/* ============================================================================
   PAPI NUT JOB — whack-a-nut pop-up
   ----------------------------------------------------------------------------
   Replaces the Subscribe & Save section, removed 2026-07-30. Fires after five
   seconds of actual scrolling, once per session. Win the round and the game
   asks for an email — that capture is the whole point of it; the game is the
   reason anyone hands it over.

   Self-contained on purpose, same as papi-cart.js: drop the script on a page
   and it injects its own styles, markup and triggers. Nothing to wire up.

   PROTOTYPE: the email goes nowhere. Point `onCapture` at the real list before
   this ships, and settle what the winner actually receives — the copy below
   deliberately promises "something" rather than inventing a discount.
   ========================================================================== */
(function () {
  'use strict';

  var SEEN_KEY  = 'papi_nutgame_seen_v1';    /* sessionStorage — once a visit  */
  var DONE_KEY  = 'papi_nutgame_done_v1';    /* localStorage  — already joined */

  var SCROLL_MS = 5000;   /* accumulated scrolling before it opens            */
  var ROUND_MS  = 20000;  /* length of a round                               */
  var TARGET    = 8;      /* nuts to whack to win                            */
  var HOLES     = 9;

  if (localStorage.getItem(DONE_KEY) || sessionStorage.getItem(SEEN_KEY)) return;

  /* Where the nut sprites live. Relative in the prototype; the Shopify
     templates set this to the CDN asset base, same as papi-cart.js. */
  var ASSETS = window.PAPI_ASSET_BASE || 'assets/';

  /* The brand's own illustrated pistachios, cut out of
     "Pistachios pattern including seamless on white background.pdf" by
     prototype/gen_nut_sprites.py. Six of them, so the board is not six copies
     of the same nut at the same angle. */
  var NUT_COUNT = 6;

  function nutImg(i) {
    return '<img src="' + ASSETS + 'papi-nut-' + ((i % NUT_COUNT) + 1) + '.png" alt="" ' +
           'draggable="false">';
  }

  var CSS = [
    '.nutg-veil{position:fixed;inset:0;z-index:940;background:rgb(20 22 15 / .62);backdrop-filter:blur(3px);opacity:0;visibility:hidden;transition:opacity .4s ease,visibility .4s}',
    '.nutg-veil.on{opacity:1;visibility:visible}',
    '.nutg{position:fixed;left:50%;top:50%;z-index:941;width:min(58rem,92vw);transform:translate(-50%,-46%) scale(.94);opacity:0;visibility:hidden;transition:opacity .45s ease,transform .45s cubic-bezier(.16,1,.3,1),visibility .45s;background:var(--papi-shell,#f9f9dd);color:var(--papi-green-dark,#3e4728);border-radius:2.4rem;padding:2.8rem 2.8rem 2.4rem;box-shadow:0 3rem 8rem rgb(20 22 15 / .45);max-height:92svh;overflow-y:auto}',
    '.nutg.on{opacity:1;visibility:visible;transform:translate(-50%,-50%) scale(1)}',
    '@media (prefers-reduced-motion:reduce){.nutg,.nutg-veil{transition:none}}',
    '.nutg__close{position:absolute;right:1.4rem;top:1.4rem;width:3.6rem;height:3.6rem;border-radius:50%;display:grid;place-items:center;font-size:2.2rem;line-height:1;color:inherit;background:rgb(62 71 40 / .1);transition:background-color .3s,transform .3s}',
    '.nutg__close:hover{background:rgb(62 71 40 / .2);transform:rotate(90deg)}',
    '.nutg__eyebrow{font-family:var(--papi-font-accent,cursive);font-size:1.9rem;color:var(--papi-green,#8e9839);display:block;line-height:1}',
    '.nutg__title{font-family:var(--papi-font-display,sans-serif);font-weight:870;text-transform:uppercase;font-size:clamp(3.2rem,6vw,4.6rem);line-height:.92;margin:.6rem 0 0}',
    '.nutg__blurb{font-size:1.55rem;line-height:1.5;margin:1.2rem 0 0}',

    /* scoreboard */
    '.nutg__hud{display:flex;align-items:center;justify-content:space-between;gap:1.2rem;margin:1.8rem 0 1.2rem;font-family:var(--papi-font-display,sans-serif);font-weight:850;text-transform:uppercase;font-size:1.7rem}',
    '.nutg__hud span b{font-size:2.4rem}',
    '.nutg__bar{height:.7rem;border-radius:99rem;background:rgb(62 71 40 / .16);overflow:hidden;margin-bottom:1.6rem}',
    '.nutg__bar i{display:block;height:100%;width:100%;background:var(--papi-green,#8e9839);transform-origin:left;transition:transform .2s linear}',

    /* board */
    '.nutg__board{display:grid;grid-template-columns:repeat(3,1fr);gap:1rem}',
    '.nutg-hole{position:relative;aspect-ratio:1;border-radius:1.6rem;background:rgb(62 71 40 / .18);box-shadow:inset 0 .4rem 1.2rem rgb(62 71 40 / .18);overflow:hidden;display:grid;place-items:end center;padding-bottom:6%}',
    '.nutg-hole__nut{width:74%;transform:translateY(118%) rotate(var(--tilt,-6deg));transition:transform .16s cubic-bezier(.34,1.56,.64,1);cursor:pointer;background:none;padding:0;display:block}',
    '.nutg-hole.up .nutg-hole__nut{transform:translateY(4%) rotate(var(--tilt,-6deg))}',
    '.nutg-hole.hit .nutg-hole__nut{transform:translateY(4%) rotate(var(--tilt,-6deg)) scale(.7);opacity:.3;transition:transform .18s ease,opacity .18s ease}',
    '.nutg-hole__nut img{display:block;width:100%;height:auto;pointer-events:none;filter:drop-shadow(0 .6rem .9rem rgb(20 22 15 / .35))}',

    /* buttons */
    '.nutg__go{width:100%;margin-top:1.8rem;border-radius:99rem;padding:1.6rem 2rem;font-family:var(--papi-font-display,sans-serif);font-weight:850;text-transform:uppercase;font-size:1.9rem;background:var(--papi-green-dark,#3e4728);color:var(--papi-shell,#f9f9dd);transition:background-color .3s,transform .25s}',
    '.nutg__go:hover{background:var(--papi-green,#8e9839);transform:translateY(-.2rem)}',
    '.nutg__skip{display:block;margin:1.2rem auto 0;font-size:1.35rem;color:inherit;opacity:.6;text-decoration:underline}',
    '.nutg__skip:hover{opacity:1}',

    /* capture */
    '.nutg__form{display:flex;margin-top:1.8rem}',
    '.nutg__form input{flex:1;min-width:0;font-family:inherit;font-size:1.55rem;padding:1.5rem 1.8rem;border:.25rem solid var(--papi-green-dark,#3e4728);border-right:none;border-radius:99rem 0 0 99rem;background:transparent;color:inherit;outline:none}',
    '.nutg__form button{font-family:var(--papi-font-display,sans-serif);font-weight:850;text-transform:uppercase;font-size:1.5rem;letter-spacing:.04em;padding:1.5rem 2.4rem;border-radius:0 99rem 99rem 0;background:var(--papi-green-dark,#3e4728);color:var(--papi-shell,#f9f9dd);border:.25rem solid var(--papi-green-dark,#3e4728)}',
    '.nutg__form button:hover{background:var(--papi-green,#8e9839);border-color:var(--papi-green,#8e9839)}',
    '.nutg__fine{font-size:1.2rem;opacity:.6;margin:1rem 0 0;text-align:center}',

    '@media (max-width:420px){.nutg{padding:2.2rem 1.8rem 2rem}.nutg__board{gap:.7rem}}'
  ].join('\n');

  var veil, panel, holes = [], timers = [], round = null;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function build() {
    var style = el('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    veil = el('div', 'nutg-veil');
    veil.addEventListener('click', dismiss);

    panel = el('aside', 'nutg');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Papi’s nut job');
    document.body.appendChild(veil);
    document.body.appendChild(panel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('on')) dismiss();
    });
  }

  /* ---------- screens ---------------------------------------------------- */

  function intro() {
    panel.innerHTML =
      '<button class="nutg__close" type="button" aria-label="No thanks">&times;</button>' +
      '<span class="nutg__eyebrow">Hold on a second</span>' +
      '<h2 class="nutg__title">A mystery prize is up for grabs… if you’re quick enough.</h2>' +
      '<p class="nutg__blurb">Papi’s got a little challenge for you! Beat the clock, whack ' +
        TARGET + ' pistachios in ' + (ROUND_MS / 1000) + ' seconds, and you could unlock a ' +
        'mystery prize.</p>' +
      '<button class="nutg__go" type="button">Let’s go</button>' +
      '<button class="nutg__skip" type="button">No thanks, I’m shopping</button>';
    panel.querySelector('.nutg__close').addEventListener('click', dismiss);
    panel.querySelector('.nutg__skip').addEventListener('click', dismiss);
    panel.querySelector('.nutg__go').addEventListener('click', play);
  }

  function play() {
    var board = '';
    for (var i = 0; i < HOLES; i++) {
      /* a per-hole tilt so the grid does not read as nine identical stamps */
      var tilt = ((i * 37) % 31) - 15;
      board += '<div class="nutg-hole" style="--tilt:' + tilt + 'deg">' +
        '<button class="nutg-hole__nut" type="button" tabindex="-1" aria-label="Whack">' +
        nutImg(i) + '</button></div>';
    }
    panel.innerHTML =
      '<button class="nutg__close" type="button" aria-label="Close">&times;</button>' +
      '<span class="nutg__eyebrow">Go on then</span>' +
      '<h2 class="nutg__title">Whack the nuts</h2>' +
      '<div class="nutg__hud"><span>Whacked <b data-score>0</b>/' + TARGET + '</span><span><b data-clock>' + (ROUND_MS / 1000) + '</b>s</span></div>' +
      '<div class="nutg__bar"><i data-bar></i></div>' +
      '<div class="nutg__board"></div>';
    panel.querySelector('.nutg__close').addEventListener('click', dismiss);

    var boardEl = panel.querySelector('.nutg__board');
    boardEl.innerHTML = board;
    holes = Array.prototype.slice.call(boardEl.querySelectorAll('.nutg-hole'));

    round = {
      score: 0, ends: null,
      scoreEl: panel.querySelector('[data-score]'),
      clockEl: panel.querySelector('[data-clock]'),
      barEl: panel.querySelector('[data-bar]')
    };

    holes.forEach(function (hole) {
      hole.querySelector('.nutg-hole__nut').addEventListener('click', function () {
        if (!round || !hole.classList.contains('up') || hole.classList.contains('hit')) return;
        hole.classList.add('hit');
        round.score++;
        round.scoreEl.textContent = round.score;
        setTimeout(function () { hole.classList.remove('up', 'hit'); }, 120);
        if (round.score >= TARGET) finish(true);
      });
    });

    /* Timers are collected so a dismissal mid-round cannot leave nuts popping
       against a torn-down panel. */
    var started = performance.now();
    round.ends = started + ROUND_MS;

    var tick = setInterval(function () {
      if (!round) return;
      var left = Math.max(0, round.ends - performance.now());
      round.clockEl.textContent = Math.ceil(left / 1000);
      round.barEl.style.transform = 'scaleX(' + (left / ROUND_MS) + ')';
      if (left <= 0) finish(round.score >= TARGET);
    }, 100);
    timers.push({ clear: function () { clearInterval(tick); } });

    pop();
  }

  function pop() {
    if (!round) return;
    var down = holes.filter(function (h) { return !h.classList.contains('up'); });
    if (down.length) {
      var hole = down[Math.floor(Math.random() * down.length)];
      hole.classList.add('up');
      /* How long each pistachio stays up. Was 620-1140ms, which tested as
         genuinely too hard — 8 hits in 20s was a struggle even knowing the
         game. Now 1000-1800ms (~60% longer). The spawn gap below is left
         alone deliberately: a longer up-time with the same gap means MORE
         nuts are up simultaneously, which adds targets rather than just
         slowing everything down. Tune here, not in the gap. */
      var upFor = 1000 + Math.random() * 800;
      var t = setTimeout(function () { hole.classList.remove('up', 'hit'); }, upFor);
      timers.push({ clear: function () { clearTimeout(t); } });
    }
    var gap = 340 + Math.random() * 320;
    var n = setTimeout(pop, gap);
    timers.push({ clear: function () { clearTimeout(n); } });
  }

  function stopTimers() {
    timers.forEach(function (t) { t.clear(); });
    timers = [];
  }

  function finish(won) {
    var score = round ? round.score : 0;
    round = null;
    stopTimers();

    if (!won) {
      panel.innerHTML =
        '<button class="nutg__close" type="button" aria-label="Close">&times;</button>' +
        '<span class="nutg__eyebrow">Oh dear</span>' +
        '<h2 class="nutg__title">' + score + ' out of ' + TARGET + '</h2>' +
        '<p class="nutg__blurb">Papi has seen better. He is prepared to pretend that did not happen.</p>' +
        '<button class="nutg__go" type="button">Go again</button>' +
        '<button class="nutg__skip" type="button">I’ll just shop, thanks</button>';
      panel.querySelector('.nutg__go').addEventListener('click', play);
    } else {
      panel.innerHTML =
        '<button class="nutg__close" type="button" aria-label="Close">&times;</button>' +
        '<span class="nutg__eyebrow">Well then</span>' +
        '<h2 class="nutg__title">Nailed it</h2>' +
        '<p class="nutg__blurb">' + score + ' nuts, no survivors. Leave your email and Papi will send ' +
          'you something for that.</p>' +
        '<form class="nutg__form" novalidate>' +
          '<input type="email" required placeholder="your@email.com" aria-label="Email address">' +
          '<button type="submit">Claim</button>' +
        '</form>' +
        '<p class="nutg__fine">One email. You can leave the famiglia whenever you like.</p>' +
        '<button class="nutg__skip" type="button">No thanks</button>';
      panel.querySelector('.nutg__form').addEventListener('submit', capture);
    }
    panel.querySelector('.nutg__close').addEventListener('click', dismiss);
    panel.querySelector('.nutg__skip').addEventListener('click', dismiss);
  }

  function capture(e) {
    e.preventDefault();
    var input = e.target.querySelector('input');
    /* Deliberately permissive — a rejected address here costs a signup, and the
       list does its own validation anyway. */
    if (!input.value || input.value.indexOf('@') < 1) { input.focus(); return; }

    /* PROTOTYPE: nothing is sent. Hook the real list up here. */
    if (typeof window.papiNutGameCapture === 'function') window.papiNutGameCapture(input.value);
    localStorage.setItem(DONE_KEY, '1');

    panel.innerHTML =
      '<button class="nutg__close" type="button" aria-label="Close">&times;</button>' +
      '<span class="nutg__eyebrow">Done</span>' +
      '<h2 class="nutg__title">You’re in</h2>' +
      '<p class="nutg__blurb">Check your inbox. Papi is not known for his patience, so it will not be long.</p>' +
      '<button class="nutg__go" type="button">Back to shopping</button>';
    panel.querySelector('.nutg__close').addEventListener('click', dismiss);
    panel.querySelector('.nutg__go').addEventListener('click', dismiss);
  }

  /* ---------- open / close ------------------------------------------------ */

  function open() {
    sessionStorage.setItem(SEEN_KEY, '1');
    intro();
    veil.classList.add('on');
    panel.classList.add('on');
    if (window.__papiLenis) window.__papiLenis.stop();
    else document.documentElement.style.overflow = 'hidden';
    var focusable = panel.querySelector('.nutg__go');
    if (focusable) focusable.focus();
  }

  function dismiss() {
    round = null;
    stopTimers();
    veil.classList.remove('on');
    panel.classList.remove('on');
    if (window.__papiLenis) window.__papiLenis.start();
    else document.documentElement.style.overflow = '';
  }

  /* ---------- the trigger: five seconds of ACTUAL scrolling ---------------- */
  /* Elapsed-since-first-scroll would fire on someone who nudged the page once
     and then read for five seconds. This only counts time while the page is
     genuinely moving. */

  function watchScroll() {
    var scrolled = 0, last = 0, armed = true;

    function onScroll() {
      var now = performance.now();
      if (last && now - last < 400) scrolled += now - last;
      last = now;
      if (armed && scrolled >= SCROLL_MS) {
        armed = false;
        window.removeEventListener('scroll', onScroll);
        open();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function boot() { build(); watchScroll(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.PapiNutGame = { open: open, close: dismiss };
})();
